/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import Card from "./Card";
import OrderCM2PerDayChart from "./chart/OrderCM2PerDayChart";
import CommentList from "./CommentList";
import HelpNote from "./HelpNote";
import PatientLifecycle from "./PatientLifecycle";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Globals from "../shared/Globals";
import Auth from "../shared/Auth";
import FormLabel from "./FormLabel";
import { Link } from "react-router-dom";

class OrderSummary extends BaseCom {
    async componentDidMount() {
        await this.getSettings();
    }


    getSalesRepUser = () => {
        if (!this.props.userList) return null;
        if (this.props.item?.salesRepUserID) {
            var user = this.props.userList.find(i => i.id === this.props.item.salesRepUserID);
            if (user)
                return user;
        }
        return null;
    }

    render() {
        return <>
            <div className="row">
                <div className="col-md">

                    <Card title="Order Details">
                        <div className="row">
                            <div className="col-md">
                                <FormLabel model={this.props.item.oid} label="ID#" />
                                <FormLabel model={this.props.item.account.name} label="Account" link={Auth.hasRole('manager') && `/account/${this.props.item.account.id}`} />
                                <FormLabel model={this.props.item.provider.name} label="Provider" link={Auth.hasRole('admin') && this.props.item.provider.id && `/provider/edit/${this.props.item.provider.id}`} />
                                {this.props.item.productName && <FormLabel model={this.props.item.productName} label="Product" />}
                                <FormLabel model={this.props.item.patientNameDOB} label="Patient" link={'/order/view/' + this.props.item.id + '/patient'} />
                                <FormLabel model={this.props.item.patient.genderLong} label="Patient Gender" />

                                {this.props.item.status === 'Discharge'
                                    ? <FormLabel model={`${this.props.item.status} (${this.props.item.dischargeStatusName})`} label="Status" />
                                    : <FormLabel model={this.props.item.status} label="Status" />}

                                {this.props.item.leadTAT ? <FormLabel model={this.props.item.leadTAT} label="Lead to Patient (TAT)" /> : null}
                                {this.props.item.totalProductSizeCM2 ? <FormLabel model={<>{this.props.item.totalProductSizeCM2} <span>cm<sup>2</sup></span></>} label="Total Product Applied" onClick={Auth.hasRole('manager') ? () => this.setState({ showProductsModal: true }) : null} /> : ''}

                                {this.getSalesRepUser()
                                    && <FormLabel model={this.getSalesRepUser().name} label="Care Coordinator" />}

                                {Auth.hasRole('manager') ? <HelpNote>Looking for the <strong>Actions</strong> dropdown? Find it at the bottom right of the screen.</HelpNote> : null}

                            </div>
                            {this.state.MODEL === 'WMS' && <div className="col-md">
                                <div className="c-formlabel mb-3">
                                    <h5>Healing Progress by cm<sup>2</sup></h5>
                                </div>
                                <OrderCM2PerDayChart orderID={this.props.item.id} />
                            </div>}
                        </div>
                    </Card>
                </div>
                <div className="col-md-4">
                    {this.props.item.patient?.photoIdent && <Card title="Photo">
                        <img src={Globals.getStorageURL(this.props.item.patient?.photoIdent, true)} alt="Patient" className="img-fluid" />
                    </Card>}

                    {this.state.MODEL === 'EHR' && !this.props.item.patient?.photoIdent && <Card title="Photo"><img src={Globals.getStorageURL(null, true)} alt="Patient" className="img-fluid" /></Card>}

                    {this.state.MODEL === 'WMS' && <PatientLifecycle order={this.props.item} onChange={this.load} />}

                    {this.state.MODEL === 'LIS' && <Card title="Specimens">
                        <ul className="list-group">
                            {this.props.item.specimens?.map((i, idx) => <li key={idx} className="list-group-item d-flex justify-content-between">
                                <div><Link to={`/specimen/${i.id}`}>{i.sid}</Link></div>
                                <div>{i.specimenTypeName}</div>
                            </li>)}
                        </ul>
                    </Card>}
                </div>
            </div>
            {!Auth.hasRole('external') && <Card title="Activity and Comments">
                <CommentList orderId={this.props.item.id} />
            </Card>}
        </>;
    }
}

export default withParamsAndNavigate(OrderSummary);